export default {
  path: 'license',
  name: 'subscription/license',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "subscription-show-license" */ './License')
}
